import { render } from "./UserPopover.vue?vue&type=template&id=763b84f0&scoped=true"
import script from "./UserPopover.vue?vue&type=script&lang=js"
export * from "./UserPopover.vue?vue&type=script&lang=js"

import "./UserPopover.vue?vue&type=style&index=0&id=763b84f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763b84f0"]])

export default __exports__